import { client } from './client'

export const getAdditionalRecommendFacilities = async (params) => {
  const response = await client.get('/api/nursing_facilities/additional_recommends/', { params })
  const data = response.data
  return data
}
